export default function meFormatter(input) {
    // 55 xxxx xxxx
    const mexPattern1 = /^52(55)([0-9]{4})([0-9]{4})$/;
    // 56 xxxx xxxx
    const mexPattern2 = /^52(56)([0-9]{4})([0-9]{4})$/;
    // 81 xxxx xxxx
    const mexPattern3 = /^52(81)([0-9]{4})([0-9]{4})$/;
    // 33 xxxx xxxx
    const mexPattern4 = /^52(33)([0-9]{4})([0-9]{4})$/;
    // xxx xxx xxxx
    const mexPattern5 = /^52([0-9]{3})([0-9]{3})([0-9]{4})$/;
    


    
    const patterns = [
        mexPattern1,
        mexPattern2,
        mexPattern3,
        mexPattern4,
        mexPattern5
    ];
    
    for (let i = 0; i < patterns.length; i += 1) {
        if (patterns[i].test(input)) {
            return input.replace(patterns[i], '+52 $1 $2 $3');
        }
    }
    
    return `+${input}`;
}